import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlCloseSmall = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M5.525 4.818 8 7.293l2.475-2.475a.5.5 0 0 1 .638-.058l.069.058a.5.5 0 0 1 0 .707L8.707 8l2.475 2.475a.5.5 0 1 1-.707.707L8 8.707l-2.475 2.475a.5.5 0 0 1-.638.058l-.069-.058a.5.5 0 0 1 0-.707L7.293 8 4.818 5.525a.5.5 0 0 1 .707-.707z"/>
      </svg>)} {...props}/>));
export default ControlCloseSmall;
